import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { openModal } from '../../../redux/modal';
import { fromBreakpoint, toBreakpoint } from '../../../styles/breakpoints';
import { textStyles, colorPalette } from '../../../styles/styleGuide';
import { HOCObserveSize } from '../utils/HOCObserveSize';
import ImageLoader from '../ui/ImageLoader';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClick: function onClick(src) {
      dispatch(openModal('#fff', {
        type: 'image',
        componentProps: {
          image: src
        }
      }));
    }
  };
};
var ImageText = /*#__PURE__*/function (_React$Component) {
  function ImageText() {
    var _this;
    _classCallCheck(this, ImageText);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ImageText, [].concat(args));
    _defineProperty(_this, "handleClick", function (src) {
      _this.props.onClick(src);
    });
    return _this;
  }
  _inherits(ImageText, _React$Component);
  return _createClass(ImageText, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        mediaId = _this$props.mediaId,
        media = _this$props.media,
        renderWidth = _this$props.renderWidth,
        alt = _this$props.alt,
        title = _this$props.title,
        components = _this$props.components,
        alignment = _this$props.alignment;
      var src = mediaId && media ? media[mediaId] : '';
      return __jsx(ImageTextContainer, {
        alignment: alignment,
        "data-id": "richText_ImageText_ImageTextContainer"
      }, __jsx(LoadContainer, {
        alignment: alignment,
        "data-id": "richText_ImageText_LoadContainer"
      }, __jsx(ImageLoader, {
        width: renderWidth,
        src: src,
        alt: alt,
        mode: "img",
        onClick: function onClick() {
          return _this2.handleClick(src);
        },
        "data-id": "richText_ImageText_ImageLoader"
      })), __jsx(TextContainer, {
        "data-id": "richText_ImageText_TextContainer"
      }, title && __jsx(Heading3, {
        "data-id": "richText_ImageText_Heading3"
      }, title), __jsx(ImageTextParagraph, {
        "data-id": "richText_ImageText_ImageTextParagraph"
      }, components)));
    }
  }]);
}(React.Component);
export default connect(null, mapDispatchToProps)(HOCObserveSize(ImageText));
var ImageTextContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 30rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: ", ";\n\n  ", ";\n"])), function (props) {
  return props.alignment === 'right' ? 'row-reverse' : 'row';
}, toBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "]))));
var TextContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1 1 0;\n"])));
var LoadContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  float: left;\n  width: 100%;\n  max-width: 100%;\n  box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.16);\n  margin-right: ", ";\n  margin-left: ", ";\n  margin-bottom: 20rem;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  > div {\n    cursor: pointer;\n  }\n"])), function (props) {
  return props.alignment === 'right' ? '0rem' : '30rem';
}, function (props) {
  return props.alignment === 'right' ? '30rem' : '0rem';
}, toBreakpoint.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-left: 0rem;\n    margin-right: 0rem;\n  "]))), fromBreakpoint.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    flex: 1 1 0;\n  "]))), fromBreakpoint.xl(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    width: 370rem;\n  "]))));
var Heading3 = styled.h3(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), textStyles.title, colorPalette.headerGrey);
var ImageTextParagraph = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 30rem;\n"])), textStyles.bodyText, colorPalette.textGrey);